// extracted by mini-css-extract-plugin
export default {"EventDetailsImage":"Styles_EventDetailsImage__Bc1Lf","EventTypesCon":"Styles_EventTypesCon__xA8wi","RegistrationBadge":"Styles_RegistrationBadge__7irg5"};